import {
  FACILITY_PREVIEW,
  FACILITY_NEW,
  FACILITY_UPDATE,
  FACILITY_REMOVE,
  FACILITY_PROCESS_SUCCESS,
  FACILITY_DATASOURCE_SUCCESS,
  FACILITY_SEARCH,
  FACILITY_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FACILITY_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case FACILITY_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case FACILITY_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case FACILITY_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case FACILITY_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case FACILITY_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case FACILITY_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case FACILITY_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}